// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6f98f07","732":"cfa4ae2b","977":"cae2134c"}[chunkId] + ".chunk.js";
};